/*
	Nos informa que a app está pronta para uso
	swagger fica ready após inicializar as apis
	oidc fica ready quando o temos um user logado
*/
export default state => 
	state.swagger.ready && state.oidc.ready